import { cn } from '@/lib/utils';
import SmallSpinner from '../ui/small-spinner';
import { LoadingSpinner } from './loading-spinner';

interface Props {
    className?: string;
    smallSpinner?: boolean;
}
export const LoadingBlock: React.FC<Props> = ({ className, smallSpinner = true }) => {
    return (
        <div className={cn('flex w-full flex-col items-center justify-center py-20', className)}>
            {smallSpinner ? <SmallSpinner /> : <LoadingSpinner />}
        </div>
    );
};
